import {
  createDirectus,
  rest,
  authentication,
  readFieldsByCollection,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function get(name) {
  return await client.request(readFieldsByCollection(name));
}

export default { get };
